import * as SportType from 'constants/SportType';

import BADMINTON_PERIOD_MAP from './Badminton/PeriodMap';
import BANDY_PERIOD_MAP from './Bandy/PeriodMap';
import BASKETBALL_PERIOD_MAP from './Basketball/PeriodMap';
import BASKETBALL_NCAA_PERIOD_MAP from './BasketballNCAA/PeriodMap';
import BEACH_VOLLEYBALL_PERIOD_MAP from './BeachVolleyball/PeriodMap';
import BIATHLON_PERIOD_MAP from './Biathlon/PeriodMap';
import BOXING_PERIOD_MAP from './Boxing/PeriodMap';
import CYBERSPORTDOTA2_PERIOD_MAP from './CyberSportDota2/PeriodMap';
import FOOTBALL_PERIOD_MAP from './Football/PeriodMap';
import HANDBALL_PERIOD_MAP from './Handball/PeriodMap';
import ICE_HOCKEY_PERIOD_MAP from './IceHockey/PeriodMap';
import TABLE_TENNIS_PERIOD_MAP from './TableTennis/PeriodMap';
import TENNIS_PERIOD_MAP from './Tennis/PeriodMap';
import VOLLEYBALL_PERIOD_MAP from './Volleyball/PeriodMap';
import WATERPOLO_PERIOD_MAP from './Waterpolo/PeriodMap';
import WHATWHEREWHEN_PERIOD_MAP from './WhatWhereWhen/PeriodMap';
import * as Period from 'constants/Period';

const sportPeriodMap = {};
sportPeriodMap[SportType.BADMINTON] = BADMINTON_PERIOD_MAP;
sportPeriodMap[SportType.BANDY] = BANDY_PERIOD_MAP;
sportPeriodMap[SportType.BASKETBALL] = BASKETBALL_PERIOD_MAP;
sportPeriodMap[SportType.BASKTBALL_NCAA] = BASKETBALL_NCAA_PERIOD_MAP;
sportPeriodMap[SportType.BEACH_VOLLEYBALL] = BEACH_VOLLEYBALL_PERIOD_MAP;
sportPeriodMap[SportType.BIATHLON] = BIATHLON_PERIOD_MAP;
sportPeriodMap[SportType.BOX] = BOXING_PERIOD_MAP;
sportPeriodMap[SportType.CYBER_SPORTS_DOTA2] = CYBERSPORTDOTA2_PERIOD_MAP;
//sportPeriodMap[SportType.CYBER_SPORTS] = CYBERSPORTDOTA2_PERIOD_MAP;
sportPeriodMap[SportType.FOOTBALL] = FOOTBALL_PERIOD_MAP;
sportPeriodMap[SportType.HANDBALL] = HANDBALL_PERIOD_MAP;
sportPeriodMap[SportType.ICE_HOCKEY] = ICE_HOCKEY_PERIOD_MAP;
sportPeriodMap[SportType.TABLE_TENNIS] = TABLE_TENNIS_PERIOD_MAP;
sportPeriodMap[SportType.TENNIS] = TENNIS_PERIOD_MAP;
sportPeriodMap[SportType.VOLLEYBALL] = VOLLEYBALL_PERIOD_MAP;
sportPeriodMap[SportType.WATER_POLLO] = WATERPOLO_PERIOD_MAP;
sportPeriodMap[SportType.WHAT_WHERE_WHEN] = WHATWHEREWHEN_PERIOD_MAP;

export default class MatchPhaseProvider {
    static getMatchPhase(sportId, periodId) {
        return sportPeriodMap[sportId][periodId];
    }

    static isMatchFinished(sportId, periodId) {
        const matchPhase = MatchPhaseProvider.getMatchPhase(sportId, periodId);
        return matchPhase === Period.FINISHED;
    }

    static isMatchNotStarted(sportId, periodId) {
        const matchPhase = MatchPhaseProvider.getMatchPhase(sportId, periodId);
        return matchPhase === Period.NOT_STARTED;
    }
}




// WEBPACK FOOTER //
// ./js/sport-betting/components/grid-control/sportGlossary/matchPhaseProvider.js